import React from 'react'

import style from './MyhouseNoticeList.module.scss'

import MyhouseNoticeListAttentionItem from '@Components/atoms/MyhouseNoticeListAttentionItem'
import MyhouseNoticeListItem from '@Components/atoms/MyhouseNoticeListItem'

type Props = {
  itemList?: any
  attentionList?: any
  emptyState?: any
}

const MyhouseNoticeList: React.FC<Props> = ({ attentionList, itemList, emptyState }: Props) => {
  return (
    <div className={style.myhouse_notice} role="tabpanel" aria-labelledby="tabCategory">
      {attentionList && <MyhouseNoticeListAttentionItem attentionList={attentionList} />}
      {emptyState && (
        <div className={`${style['myhouse_notice_exception']} ${style['type_empty']}`} aria-hidden={emptyState.isHidden}>
          <p className={style.myhouse_exception_text}>{emptyState.text}</p>
        </div>
      )}
      {itemList && <MyhouseNoticeListItem itemList={itemList} />}
    </div>
  )
}

export default MyhouseNoticeList
